import React, { ReactNode, useRef, useEffect } from "react";

import Header from "../sub_components/Header";
import Sidebar from "../sub_components/Sidebar";
import Breadcrumb from "../sub_components/Breadcrumb";

const MainLayout = ({ children }: { children: ReactNode }) => {
    const headerRef = useRef<HTMLDivElement>(null);
    const layoutContentRef = useRef<HTMLDivElement>(null);

    const setLayoutContentHeight = () => {
        if (layoutContentRef.current) {
            layoutContentRef.current.style.height = `${window.innerHeight - (headerRef?.current?.offsetHeight ?? 0)}px`;
        };
    };

    useEffect(() => {
        setLayoutContentHeight();
    }, []);

    useEffect(() => {
        window.addEventListener('resize', setLayoutContentHeight);

        return () => {
            window.removeEventListener('resize', setLayoutContentHeight);
        };
    }, []);

    return (
        <div className="immersion__main_layout">
            <Header ref={headerRef} />
            <div
                ref={layoutContentRef}
                className="immersion__main_layout_content"
            >
                <Sidebar />
                <div className="immersion__main_layout__children">
                    <Breadcrumb />
                    <div className="immersion__main_layout__page_views">
                        <div className="immersion__main_layout__page_views__inner">
                            {children}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MainLayout;